// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import { useEffect, useState } from "react";
// import { Routes, Route, useLocation } from "react-router-dom";
// import AOS from "aos";
// import "aos/dist/aos.css";
// import "bootstrap/dist/css/bootstrap.min.css";

// import Header from "./components/Header/Header";
// import Footer from "./components/Footer/Footer";
// import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
// import ScrollToTopOnRouteChange from "./components/ScrollToTop/ScrollToTopOnRouteChange";
// import Preloader from "./components/Preloader/Preloader";

// import Home from "./pages/Home";
// import Register from "./pages/Register";
// import Login from "./pages/Login";
// import ForgotPassword from "./pages/ForgotPassword";
// import ResetPassword from "./pages/ResetPassword";
// import About from "./pages/About";
// import Courses from "./pages/Courses";
// import Contact from "./pages/Contact";
// import CourseDetail from "./pages/CourseDetail";
// import FAQS from "./pages/FAQS";
// import PrivacyPolicy from "./pages/PrivacyPolicy";
// import Terms from "./pages/Terms";
// import Checkout from "./pages/Checkout";
// import Search from "./pages/Search";
// import { ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import "./styles/ToastStyles.css";
// import "./App.css";
// import Profile from "./pages/Profile";
// import Cart from "./pages/Cart";
// import NotFound from "./components/NotFound/NotFound";

// function App() {
//   const location = useLocation(); // Track current route
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     AOS.init({ duration: 1000, once: true });
//   }, []);

//   useEffect(() => {
//     setLoading(true);
//     const timer = setTimeout(() => {
//       setLoading(false);
//     }, 700);

//     return () => clearTimeout(timer);
//   }, [location.pathname]);

//   return (
//     <>
//       <ScrollToTopOnRouteChange />
//       {loading && <Preloader />}

//       {!loading && (
//         <>
//           <Header />
//           <Routes>
//             <Route path="/" element={<Home />} />
//             <Route path="/register" element={<Register />} />
//             <Route path="/login" element={<Login />} />
//             <Route path="/forgot-password" element={<ForgotPassword />} />
//             <Route path="/reset-password" element={<ResetPassword />} />
//             <Route path="/about" element={<About />} />
//             <Route path="/courses" element={<Courses />} />
//             <Route path="/contact" element={<Contact />} />
//             <Route path="/course/:name" element={<CourseDetail />} />
//             <Route path="/faq" element={<FAQS />} />
//             <Route path="/privacy-policy" element={<PrivacyPolicy />} />
//             <Route path="/terms" element={<Terms />} />
//             <Route path="/checkout" element={<Checkout />} />
//             <Route path="/search" element={<Search />} />
//             <Route path="/profile" element={<Profile />} />
//             <Route path="/cart" element={<Cart />} />
//           </Routes>
//           <Footer />
//           <Route path="*" element={<NotFound />} />
//         </>
//       )}

//       <ScrollToTop />

//       <ToastContainer
//         position="top-center"
//         autoClose={1500}
//         hideProgressBar={false}
//         newestOnTop={true}
//         closeOnClick
//         pauseOnFocusLoss
//         draggable
//         pauseOnHover
//         toastClassName="custom-toast"
//         bodyClassName="custom-toast-body"
//       />
//     </>
//   );
// }

// export default App;


import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useEffect, useState } from "react";
import { Routes, Route, useLocation, matchPath } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";

import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import ScrollToTopOnRouteChange from "./components/ScrollToTop/ScrollToTopOnRouteChange";
import Preloader from "./components/Preloader/Preloader";

import Home from "./pages/Home";
import Register from "./pages/Register";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import About from "./pages/About";
import Courses from "./pages/Courses";
import Contact from "./pages/Contact";
import CourseDetail from "./pages/CourseDetail";
import FAQS from "./pages/FAQS";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";
import Checkout from "./pages/Checkout";
import Search from "./pages/Search";
import Profile from "./pages/Profile";
import Cart from "./pages/Cart";
import NotFound from "./components/NotFound/NotFound";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./styles/ToastStyles.css";
import "./App.css";
import ConfirmOrder from "./pages/ConfirmOrder";
import RefundPolicy from "./pages/RefundPolicy";

function App() {
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => {
      setLoading(false);
    }, 700);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  // ✅ All valid routes list
  const validRoutes = [
    "/",
    "/register",
    "/login",
    "/forgot-password",
    "/reset-password",
    "/about",
    "/courses",
    "/contact",
    "/faq",
    "/privacy-policy",
    "/refund-policy",
    "/terms",
    "/checkout",
    "/search",
    "/profile",
    "/cart",
  ];

  // ✅ Check if current route is valid
  const isCourseDetail = matchPath("/course/:name", location.pathname);
  const isValidRoute =
    validRoutes.includes(location.pathname) || isCourseDetail;

  // ❌ Hide layout on invalid routes (404)
  const hideLayout = !isValidRoute;

  return (
    <>
      <ScrollToTopOnRouteChange />
      {loading && <Preloader />}

      {!loading && (
        <>
          {/* ✅ Header */}
          {!hideLayout && <Header />}

          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/register" element={<Register />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/about" element={<About />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/course/:name" element={<CourseDetail />} />
            <Route path="/faq" element={<FAQS />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/search" element={<Search />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/cart" element={<Cart />} />

            {/* ✅ 404 Route */}
            <Route path="*" element={<NotFound />} />
            <Route path="/confirm-order/:order_id" element={<ConfirmOrder />} />
          </Routes>

          {/* ✅ Footer */}
          {!hideLayout && <Footer />}
        </>
      )}

      <ScrollToTop />

      <ToastContainer
        position="top-center"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        toastClassName="custom-toast"
        bodyClassName="custom-toast-body"
      />
    </>
  );
}

export default App;